document.addEventListener("DOMContentLoaded", () => {
  for (const menu of document.querySelectorAll("details.mobile-menu")) {
    const summary = menu.querySelector("summary");

    for (const link of menu.querySelectorAll("a")) {
      link.addEventListener("click", () => {
        menu.open = false;
      });
    }

    menu.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && menu.open) {
        event.preventDefault();
        menu.open = false;
        summary.focus();
      }
    });
  }
});
